const whole = new Intl.NumberFormat('en-US');
const compact = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 });

/** 12,345 · uses a real minus sign for negatives. */
export function fmt(n: number): string {
  return whole.format(n).replace('-', '−');
}

/** 12.3K for tight spaces; exact below 10,000. */
export function fmtShort(n: number): string {
  return Math.abs(n) < 10_000 ? fmt(n) : compact.format(n).replace('-', '−');
}

export function fmtDuration(ms: number): string {
  const totalMin = Math.floor(ms / 60_000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h > 0) return `${h}h ${m}m`;
  const s = Math.floor(ms / 1000) % 60;
  return `${m}m ${String(s).padStart(2, '0')}s`;
}

export function ordinal(n: number): string {
  const v = n % 100;
  const suffix = v >= 11 && v <= 13 ? 'th' : (['th', 'st', 'nd', 'rd'][n % 10] ?? 'th');
  return `${fmt(n)}${suffix}`;
}
